import { useCallback, useEffect, useState } from "react";
import apiCalls from "src/api/apiCalls";
import Loader from "src/components/loader.component";
import { getKpis } from "../api";
import { NumericFormat } from "react-number-format";
import { Alert } from "antd";

const CustomersKpis = () => {
    const [kpiData, setKpiData] = useState({ data: null, loading: false, error: null });
    useEffect(() => {
        fetchKpiData();
    }, []);

    const fetchKpiData = async () => {
        setKpiData({ data: null, loading: true, error: null });
        try {
            const response = await getKpis('KPI/Customers');
            if (response?.ok) {
                setKpiData({ data: response.data, loading: false, error: null });
            } else {
                throw new Error(apiCalls.isErrorDispaly(response));
            }
        } catch (error) {
            setKpiData({ data: null, loading: false, error: apiCalls.isErrorDispaly(error) });
        }
    };
    const closeError = useCallback(() => {
        setKpiData({ ...kpiData, error: null });
    }, [kpiData]);
    return (
        <>
            {kpiData.loading && <Loader />}
            {kpiData.error && (
                <Alert
                    className='mb-6'
                    type="error"
                    description={kpiData.error}
                    onClose={closeError}
                    showIcon
                    closable
                />
            )}
            <div className="grid md:grid-cols-4 gap-5">
                {!kpiData.loading && kpiData?.data?.length > 0 && (
                    kpiData?.data?.map((item) => (
                        <div className="border border-StrokeColor p-4 rounded-5" key={item?.name}>
                            <div >
                                <p className="text-paraColor text-sm font-normal">
                                    {item?.name}
                                </p>
                                <NumericFormat
                                    value={item?.count || 0}
                                    displayType="text"
                                    thousandSeparator
                                    decimalScale={0}
                                    className="text-md text-subTextColor font-semibold"
                                />
                            </div>
                        </div>
                    )))}
            </div>
        </>
    );
};

export default CustomersKpis;
